module.exports = __webpack_public_path__ + "static/media/cash.663ca727.svg";